import { Box, MenuItem, Select } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { useSelector } from "react-redux"

type Props = {
  ops: any
  fieldHandler: any
  index: any
}

const StyledDropdown = (props: Props) => {
  const { ops, fieldHandler, index } = props

  const isLoading: any = useSelector((state: any) => state.app.loading)
  const doctorList: any = useSelector(
    (state: any) => state.doctorCompensation.doctorList,
  )

  return (
    <Select
      key={ops.label}
      type={ops?.type}
      error={ops.error}
      onChange={(e) => fieldHandler(e, index)}
      fullWidth
      IconComponent={ExpandMoreIcon}
      value={ops.value}
      renderValue={() => ops.value}
      // defaultValue=""
      MenuProps={{
        sx: {
          px: 1,
        },
      }}
      variant="outlined"
    >
      {isLoading ? (
        <Box>Loading...</Box>
      ) : ops.key == "provider_name" ? (
        doctorList?.map((option: any) => {
          return (
            <MenuItem
              value={option}
              sx={{
                fontWeight: "bold",
                m: 1,
                borderRadius: "5px",
                textAlign: "center",
              }}
            >
              {option}
            </MenuItem>
          )
        })
      ) : (
        ops?.options?.map((option: any) => {
          return (
            <MenuItem
              value={option}
              sx={{
                fontWeight: "bold",
                m: 1,
                borderRadius: "5px",
                textAlign: "center",
              }}
            >
              {option}
            </MenuItem>
          )
        })
      )}
    </Select>
  )
}

export default StyledDropdown
